<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('configClient.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-addOrEdit" @click="openPopUpPrevention = true">
              {{ $t('general.button.edit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mgt-20px is-multiline">
      <div class="column is-12">
        <error-msg-component :error="true"
                             :can-close="false"
                             :title="'general.warning'"
                             :messages="[{ message: 'configClient.messages.warning.edit' }]"
        >
        </error-msg-component>
      </div>
      <div class="column is-12">
        <table  class="VueTables__table table is-bordered is-fullwidth is-striped">
          <thead >
            <th >
              {{$t('paramInterne.titre_nom')}}
            </th>
            <th>
              {{$t('paramInterne.titre_description')}}
            </th>
            <th  class="width-30">
              {{$t('paramInterne.titre_valeur')}}
            </th>
          </thead>
          <tbody>
            <tr  v-for="(param, index) in tabParams" :key="index" class="height-60">
              <td class="has-text-weight-bold vertical-alignment">
                {{$t(param.traduction)}}
              </td>
              <td class="vertical-alignment">
                {{$t(param.traduction + '_description')}}
              </td>
              <td class="vertical-alignment">
                <qd-switch v-if="param.type === Boolean"
                          v-model="param.value" class="mgt-5px">
                </qd-switch>
                <b-input v-model="param.value"
                        v-else
                        :type="param.type ? param.type.toString() : null">
                </b-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal v-model="openPopUpPrevention" width="500px">
      <pop-up-prevention
        :messHeader="$t('configClient.messages.warning.prevention')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="openPopUpPrevention = false"
        @yes="editParams()"
      />
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { changeSetting, get } from '@/api/settings';
import breadcrumb from '@/components/general/breadcrumb';
import messageSuccess from '@/services/general/messageSucces';
import PopUpPrevention from '@/components/general/popUpPrevention';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { LOCALISATION_CONFIGURATION } from '@/configuration/general/paramConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      tabParams: [],
      openPopUpPrevention: false,
    };
  },
  components: {
    breadcrumb,
    PopUpPrevention,
    errorMsgComponent,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('configClient.breadcrumb.config'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterneForce: 'loadParametreInterneForce',
    }),
    async updateTabParams() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.tabParams = [];
        const promiseTabParam = [];
        const keys = [];
        Object.values(PARAMETRES_INTERNE_KEYS).forEach((param) => {
          if (param.localisation !== LOCALISATION_CONFIGURATION) return;
          promiseTabParam.push(get(param.key));
          const cloneParam = cloneDeep(param);
          cloneParam.value = '';
          keys.push(cloneParam.key);
          this.tabParams.push(cloneParam);
        });
        const rsltParams = (await Promise.all(promiseTabParam));
        for (let i = 0; i < keys.length; i += 1) {
          const paramFind = this.tabParams.find((param) => {
            return param.key === keys[i];
          });
          if (!paramFind) return;
          paramFind.value = rsltParams[i].data.result;
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async editParams() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promiseParamUpdate = [];
        this.tabParams.forEach((param) => {
          promiseParamUpdate.push(changeSetting(param.key, param.value));
        });
        await Promise.all(promiseParamUpdate);
        const promiseForceUpdate = [];
        this.tabParams.forEach((param) => {
          promiseForceUpdate.push((this.loadParametresInterneForce(param.key)));
        });
        await Promise.all(promiseForceUpdate);
        await this.updateTabParams();
        messageSuccess(this.$i18n.t('configClient.messages.success.edit'));
        loadingComponent.close();
        await this.$router.go(0);
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.updateTabParams();
      this.setInformationPage(this.$t('pageConfigInterne.configClient.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
